import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getSingleProductbyEcommerce } from "../../../actions/singleProductAction";
import { getAllCategory } from "../../../actions/categoryAction";
import ActiveRenderTable from "./ActiveRendertable";
import {
  Skeleton,
  Tabs,
  Row,
  Col,
  AutoComplete,
  Divider,
  TreeSelect,
  Spin,
  Checkbox,
  Space,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const ProductList = ({
  getSingleProductbyEcommerce,
  List,
  updatelist,
  setUpdatelist,
  setselectedproduct,
  totalitems,
  getAllCategory,
  categoryList,
}) => {
  const [data, setdata] = useState(false);
  const [products, setproducts] = useState(false);
  const loading = useRef(true);
  const pageno = useRef(1);
  const page_size = useRef(10);
  const keytab = useRef(true);
  const keyward = useRef("");
  const searchCategory = useRef("");
  const [reload, setreload] = useState(false);
  const searchProductDiscount = useRef("");
  const searchIsEcommerce = useRef("");
  const searchIsNewArrival = useRef("");
  const searchIsBestSeller = useRef("");
  

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(true);
    }
  };

  function callback(key) {
    console.log(key);
    pageno.current = 1;
    if (key == 1) {
      keytab.current = true;
    } else {
      keytab.current = false;
    }
    setreload(true);
  }

  useEffect(() => {
    getAllCategory();
    getSingleProductbyEcommerce(
      keytab.current,
      keyward.current,
      searchCategory.current,
      "",
      "",
      pageno.current,
      page_size.current,
      // searchProductDiscount.current ? 1 : ""
      searchProductDiscount.current, 
      "",
      // searchIsEcommerce.current, 
      searchIsNewArrival.current,
      searchIsBestSeller.current,
    ).then((result) => {
      setproducts(result);
      setUpdatelist(true);
      setdata(true);
      setreload(false);
    });
  }, [reload]);

  // const onProductDiscountChange = (e) => {
  //   searchProductDiscount.current = e.target.checked;
  //   pageno.current = 1;
  //   setreload(true);
  // };
  const onProductDiscountChange = (e) => {  // Add this function
    if (e.target.checked) {
      searchProductDiscount.current = 0;
    } else {
      searchProductDiscount.current = "";
    }
    setreload(true);
  };
  
  const onEcommerceChange = (e) => {
    if (e.target.checked) {
      searchIsEcommerce.current = true;
    } else {
      searchIsEcommerce.current = "";
    }
    setreload(true);
  };
  const onNewArrivalChange = (e) => {
    if (e.target.checked) {
      searchIsNewArrival.current = true;
    } else {
      searchIsNewArrival.current = "";
    }
    setreload(true);
  };
  const onBestSellerChange = (e) => {
    if (e.target.checked) {
      searchIsBestSeller.current = true;
    } else {
      searchIsBestSeller.current = "";
    }
    setreload(true);
  };

  const rendertable = () => {
    if (reload) {
      return (
        <>
          <span style={{ marginTop: "30px" }}>
            <Spin indicator={antIcon} /> loading
          </span>
        </>
      );
    }
  };

  if (data) {
    return (
      <>
        <Row>
          <Col span={8}>
            <h3>Enter product title for instant Search</h3>
            <AutoComplete
              placeholder="input search text"
              onKeyUp={onChange}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={5} offset={1}>
            <h3>Category</h3>

            <TreeSelect
              style={{ width: "100%" }}
              treeData={categoryList}
              onChange={(value) => {
                pageno.current = 1;
                searchCategory.current = value;
                setreload(true);
              }}
            />
          </Col>
          <Col offset={1}>
            <Row style={{ color: "white" }}>
              .
            </Row>
            <Row style={{ color: "white" }}>
              .
            </Row>

            <Row>
              {/* <Space direction="vertical">
                <Checkbox  onChange={onProductDiscountChange} >
                  <h3>Show Discounted Products</h3>
                </Checkbox>
              </Space> */}
              <Space direction="vertical">
                <Checkbox onChange={onNewArrivalChange}> 
                  <h3>Show New Arrival</h3>
                </Checkbox>
              </Space>
              <Space direction="vertical">
                <Checkbox onChange={onBestSellerChange}> 
                  <h3>Show Best Seller</h3>
                </Checkbox>
              </Space>
            </Row>


          </Col>
          {/* <Col offset={1}>{rendertable()}</Col> */}
        </Row>
        <Divider />
        <Spin spinning={reload}>
          <Tabs defaultActiveKey="1" onChange={callback}>
            <TabPane tab="E-commerce Products" key="1">
              <ActiveRenderTable
                List={products.results}
                setUpdatelist={setUpdatelist}
                setselectedproduct={setselectedproduct}
                pageno={pageno}
                page_size={page_size}
                totalitems={totalitems}
                setreload={setreload}
              />
            </TabPane>
            
          </Tabs>
        </Spin>
      </>
    );
  } else {
    return (
      <>
        <Skeleton active />
        <Skeleton active />
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    List: state.singleProduct.sinleproductlist.results,
    totalitems: state.singleProduct.sinleproductlist.count,
    categoryList: state.category.categorylist,
  };
};

export default connect(mapStateToProps, {
  getSingleProductbyEcommerce,
  getAllCategory,
})(ProductList);
